export const cards = [
  {
    title: 'Github Links',
    description: 'Choose your repo, create a card and share it on Twitter',
    tools: ['react', 'redux', 'axios', 'lodash', 'sass', 'styled-components'],
    code: 'https://github.com/irinagastmaier/github-links',
    image: [
      '/img/github_links_1.jpg',
      '/img/github_links_3.jpg',
      '/img/github_links_4.jpg',
      '/img/github_links_5.jpg',
    ],
  },
  {
    title: 'Harbey Spaceships',
    description:
      'Find information about every spaceship available for traveling',
    tools: ['react', 'spacex api', 'apollo client', 'graphql', 'react chakra'],
    code: 'https://github.com/irinagastmaier/harbey-spaceships',
    image: [
      '/img/harbey_spaceships_1.jpg',
      '/img/harbey_spaceships_2.jpg',
      '/img/harbey_spaceships_3.jpg',
      '/img/harbey_spaceships_4.jpg',
    ],
  },
  {
    title: 'Fullstack',
    description:
      'Change the state of the SPAM report and block it from the main page.',
    tools: ['react', 'nodejs', 'lowdb', 'express'],
    code: 'https://github.com/irinagastmaier/fullstack-challenge',
    image: ['/img/fullstack_1.png'],
  },
  {
    title: 'Kitacare',
    description: 'DCI Final Project',
    tools: [
      'react',
      'Context API ',
      'sass',
      ' Node.Js',
      'Express',
      'JSON Web Token',
      'MongoDB',
    ],
    code: 'https://github.com/irinagastmaier/kitacare',
    image: ['/img/kitacare_1.jpg', '/img/kitacare_2.jpg'],
  },
];
